import { Observable } from "rxjs";
import {
  IAllowableActivityDTO,
  IAllowableResponsibleDTO,
} from "../../models/currentUser";

export abstract class CurrentUserApi {
  public abstract getAllowableResponsibles(): Observable<
    IAllowableResponsibleDTO[]
  >;
  public abstract getAllowableActivities(): Observable<IAllowableActivityDTO[]>;
}
